// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"d5af952f","990":"d68e2741"}[chunkId] + ".chunk.css";
};